export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}company/company`;
    const url = `${baseUrl}/:id`;

    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        verifySlug: {
            method: 'POST',
            url: `${url}/verify-slug`
        },
        statistics: {
            method: 'GET',
            isArray: false,
            url: `${url}/statistics`
        },
        terms: {
            method: 'GET',
            url: `${url}/terms`
        },
        certificates: {
            method: 'GET',
            url: `${url}/certificates`,
            isArray: true
        },
        publicView: {
            method: 'GET',
            url: `${url}/public-view`
        },
        setNotificationReceivingHours: {
            method: 'POST',
            url: `${baseUrl}/set-notification-receiving-hours`
        },
        generateIntegrationToken: {
            method: 'POST',
            url: `${baseUrl}/generate-integration-token`
        },
        removeIntegrationToken: {
            method: 'DELETE',
            url: `${baseUrl}/remove-integration-token/:id`
        },
        integrationToken: {
            method: 'GET',
            url: `${baseUrl}/integration-token`
        },
        ssoSetting: {
            method: 'GET',
            url: `${baseUrl}/sso-setting`
        },
        saveSsoSetting: {
            method: 'POST',
            url: `${baseUrl}/save-sso-setting`
        },
        inactiveUserAnonymizationPreview: {
            method: 'GET',
            url: `${baseUrl}/inactive-user-anonymization-preview`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/Company/index.js